import validator from 'validator';
import find from 'lodash/find';
import {
  isEmptyOrContainsOnlySpaces,
  isNullOrEmpty,
  keyErrorsFieldRequired,
  removeNonDigitCharacters,
  isMedicareChecksumCorrect,
} from 'utils/helpers';
import {
  workStatuses, BOARDING, RENT,
} from 'consts';
import { REGISTRATION_CONSENTS_KEYS, incomeAmountLimits } from 'consts/loan/AU';
import { drivingLicenceRules } from '../../../consts/loan/AU/identDocument';

const validateLoan = (values) => {
  const errors = {};

  const {
    occupation,
    identDocumentType,
    newPassword,
    newPasswordConfirm,
  } = values;

  // IMPERSONATION COMPLETE REGISTRATION

  if (!newPassword) {
    errors.newPassword = keyErrorsFieldRequired;
  } else if (
    newPassword.length < 8
    || newPassword.length > 20
    || !newPassword.match(/[a-z]/)
    || !newPassword.match(/[A-Z]/)
    || !newPassword.match(/[ `¡¿!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/)
    || !newPassword.match(/\d+/g)
  ) {
    errors.newPassword = 'errors.field.newPassword';
  }

  if (!newPasswordConfirm || newPasswordConfirm !== newPassword) {
    errors.newPasswordConfirm = 'errors.field.newPasswordConfirm';
  }

  if (!values.instantMessenger) {
    errors.instantMessenger = keyErrorsFieldRequired;
  }

  REGISTRATION_CONSENTS_KEYS.forEach((checkbox) => {
    if (!values[checkbox]) {
      errors[checkbox] = keyErrorsFieldRequired;
    }
  });

  // FAMILY_AU
  if (isNullOrEmpty(values.gender)) {
    errors.gender = keyErrorsFieldRequired;
  }

  if (isNullOrEmpty(values.residencyStatus)) {
    errors.residencyStatus = keyErrorsFieldRequired;
  }

  if (isNullOrEmpty(values.countryOfOrigin)) {
    errors.countryOfOrigin = keyErrorsFieldRequired;
  }

  if (isNullOrEmpty(values.maritalStatus)) {
    errors.maritalStatus = keyErrorsFieldRequired;
  }

  if (isNullOrEmpty(values.numberOfDependants)) {
    errors.numberOfDependants = keyErrorsFieldRequired;
  }

  if (isNullOrEmpty(values.soleEarnerIndicator)) {
    errors.soleEarnerIndicator = keyErrorsFieldRequired;
  }

  // ADDRESS_AU
  if (isNullOrEmpty(values.residentialStatus)) {
    errors.residentialStatus = keyErrorsFieldRequired;
  }
  if (isNullOrEmpty(values.addressState)) {
    errors.addressState = keyErrorsFieldRequired;
  }

  if (isEmptyOrContainsOnlySpaces(values.streetNumber)) {
    errors.streetNumber = keyErrorsFieldRequired;
  }

  if (isEmptyOrContainsOnlySpaces(values.street)) {
    errors.street = keyErrorsFieldRequired;
  }

  if (!values.postCode) {
    errors.postCode = keyErrorsFieldRequired;
  }

  if (isEmptyOrContainsOnlySpaces(values.city)) {
    errors.city = keyErrorsFieldRequired;
  }

  if (
    errors.addressState
    && errors.streetNumber
    && errors.street
    && errors.postCode
    && errors.city
  ) {
    errors.geoSuggestErrorMessage = 'errors.message.address';
  }

  // EDUCATION_WORK
  if (isNullOrEmpty(values.education)) {
    errors.education = keyErrorsFieldRequired;
  }

  const workingStateType = find(workStatuses, (item) => item.type === occupation) || {};
  if (isNullOrEmpty(occupation)) {
    errors.occupation = keyErrorsFieldRequired;
  } else if (workingStateType.areDetailsNeeded) {
    const { secondJob } = values;
    if (isNullOrEmpty(values.employmentDuration)) {
      errors.employmentDuration = keyErrorsFieldRequired;
    }
    if (isEmptyOrContainsOnlySpaces(values.jobTitle)) {
      errors.jobTitle = keyErrorsFieldRequired;
    }
    if (isEmptyOrContainsOnlySpaces(values.company)) {
      errors.company = keyErrorsFieldRequired;
    }
    if (!secondJob) {
      errors.secondJob = keyErrorsFieldRequired;
    } else if (secondJob === 'yes' && isEmptyOrContainsOnlySpaces(values.secondCompany)) {
      errors.secondCompany = keyErrorsFieldRequired;
    }
  }

  // IDENT_DOCUMENTS
  if (isNullOrEmpty(identDocumentType)) {
    errors.identDocumentType = keyErrorsFieldRequired;
  } else if (identDocumentType === 'drivingLicence') {
    const {
      drivingCardNumber,
      drivingLicenceNumber,
      drivingLicenceState,
      drivingLicenceExpirationDay,
      drivingLicenceExpirationMonth,
      drivingLicenceExpirationYear,
    } = values;
    if (!drivingLicenceNumber) {
      errors.drivingLicenceNumber = keyErrorsFieldRequired;
    } else if (drivingLicenceState) {
      const rule = drivingLicenceRules[drivingLicenceState];
      const isDrivingLicenceNumberInvalid = rule
        && !rule.pattern.test(drivingLicenceNumber);
      if (isDrivingLicenceNumberInvalid) {
        errors.drivingLicenceNumber = rule.message;
      }
    }
    if (isNullOrEmpty(drivingLicenceState)) {
      errors.drivingLicenceState = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(drivingLicenceExpirationDay)) {
      errors.drivingLicenceExpirationDay = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(drivingLicenceExpirationMonth)) {
      errors.drivingLicenceExpirationMonth = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(drivingLicenceExpirationYear)) {
      errors.drivingLicenceExpirationYear = keyErrorsFieldRequired;
    }
  } else if (identDocumentType === 'medicare') {
    const {
      medicareReferenceNumber,
      medicareNumber,
      cardColour,
      medicareExpirationDay,
      medicareExpirationMonth,
      medicareExpirationYear,
    } = values;
    if (!medicareNumber) {
      errors.medicareNumber = keyErrorsFieldRequired;
    } else if (!validator.matches(medicareNumber, /^[2-6]\d{9}$/)) {
      errors.medicareNumber = 'errors.field.medicareNumber';
    } else if (!isMedicareChecksumCorrect(medicareNumber)) {
      errors.medicareNumber = 'errors.field.medicareNumber';
    }
    if (isNullOrEmpty(medicareReferenceNumber)) {
      errors.medicareReferenceNumber = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(cardColour)) {
      errors.cardColour = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(medicareExpirationDay)) {
      errors.medicareExpirationDay = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(medicareExpirationMonth)) {
      errors.medicareExpirationMonth = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(medicareExpirationYear)) {
      errors.medicareExpirationYear = keyErrorsFieldRequired;
    }
  } else if (identDocumentType === 'passport') {
    const {
      passportNumber,
      countryOfIssue,
      passportExpirationDay,
      passportExpirationMonth,
      passportExpirationYear,
    } = values;

    if (!passportNumber) {
      errors.passportNumber = keyErrorsFieldRequired;
    } else if (!validator.matches(passportNumber, /^[\da-zA-Z]{6,10}$/)) {
      errors.passportNumber = 'errors.field.passportNumber';
    }
    if (isNullOrEmpty(countryOfIssue)) {
      errors.countryOfIssue = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(passportExpirationDay)) {
      errors.passportExpirationDay = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(passportExpirationMonth)) {
      errors.passportExpirationMonth = keyErrorsFieldRequired;
    }
    if (isNullOrEmpty(passportExpirationYear)) {
      errors.passportExpirationYear = keyErrorsFieldRequired;
    }
  }

  // INCOME_AU
  const incomeAmount = removeNonDigitCharacters(values.incomeAmount);

  if (!incomeAmount) {
    errors.incomeAmount = keyErrorsFieldRequired;
  } else {
    const selectedFrequency = values.incomeFrequency;
    const limit = incomeAmountLimits[selectedFrequency];
    const amountLimit = limit && incomeAmount >= limit;

    if (amountLimit) {
      errors.incomeAmount = 'errors.field.incomeAmount.above';
    }
  }

  if (!values.incomeFrequency) {
    errors.incomeFrequency = keyErrorsFieldRequired;
  }
  if (!values.governmentBenefits) {
    errors.governmentBenefits = keyErrorsFieldRequired;
  } else if (values.governmentBenefits === 'yes') {
    if (!values.governmentBenefitsAmount) {
      errors.governmentBenefitsAmount = keyErrorsFieldRequired;
    }
    if (!values.governmentBenefitsFrequency) {
      errors.governmentBenefitsFrequency = keyErrorsFieldRequired;
    }
  }
  if (!values.incomePayDayDate) {
    errors.incomePayDayDate = keyErrorsFieldRequired;
  }

  // EXPENSES_AU
  const isAccommodationCostsIsRequired = values.residentialStatus === RENT
    || values.residentialStatus === BOARDING;
  const checkAccommodationCosts = isNullOrEmpty(values.housingCosts) || values.housingCosts === '0';
  const checkEssentialExpenses = isNullOrEmpty(values.essentialExpenses) || values.essentialExpenses === '0';
  const checkNonEssentialExpenses = values.nonEssentialExpenses > 0
    && isNullOrEmpty(values.nonEssentialExpensesFrequency);

  if (INCREASE_APP) {
    if (!removeNonDigitCharacters(values.housingCosts)) {
      errors.housingCosts = keyErrorsFieldRequired;
    }

    if (!values.foodGroceriesExpenses) {
      errors.foodGroceriesExpenses = keyErrorsFieldRequired;
    }
    if (!values.transportExpenses) {
      errors.transportExpenses = keyErrorsFieldRequired;
    }
    if (!values.healthMedicalExpenses) {
      errors.healthMedicalExpenses = keyErrorsFieldRequired;
    }
    if (!values.insuranceExpenses) {
      errors.insuranceExpenses = keyErrorsFieldRequired;
    }
    if (!values.utilitiesExpenses) {
      errors.utilitiesExpenses = keyErrorsFieldRequired;
    }
    if (!values.phoneInternetExpenses) {
      errors.phoneInternetExpenses = keyErrorsFieldRequired;
    }
    if (!values.housingCostsFrequency) {
      errors.housingCostsFrequency = keyErrorsFieldRequired;
    }
  } else {
    if (isAccommodationCostsIsRequired) {
      if (checkAccommodationCosts) {
        errors.housingCosts = keyErrorsFieldRequired;
      }
      if (isNullOrEmpty(values.housingCostsFrequency)) {
        errors.housingCostsFrequency = keyErrorsFieldRequired;
      }
    }

    if (checkAccommodationCosts) {
      errors.housingCosts = keyErrorsFieldRequired;
    }

    if (isNullOrEmpty(values.housingCostsFrequency)) {
      errors.housingCostsFrequency = keyErrorsFieldRequired;
    }

    if (checkEssentialExpenses) {
      errors.essentialExpenses = keyErrorsFieldRequired;
    }

    if (isNullOrEmpty(values.essentialExpensesFrequency)) {
      errors.essentialExpensesFrequency = keyErrorsFieldRequired;
    }

    if (checkNonEssentialExpenses) {
      errors.nonEssentialExpensesFrequency = keyErrorsFieldRequired;
    }

    if (!removeNonDigitCharacters(values.totalLivingExpenses)) {
      errors.totalLivingExpenses = keyErrorsFieldRequired;
    }
  }

  // LOANS_AU

  if (INCREASE_APP) {
    if (!values.loanPayments) {
      errors.loanPayments = keyErrorsFieldRequired;
    } else if (values.loanPayments === 'yes') {
      if (!values.loanPaymentsCount) {
        errors.loanPaymentsCount = keyErrorsFieldRequired;
      }
      if (!removeNonDigitCharacters(values.totalRepayments)) {
        errors.totalRepayments = keyErrorsFieldRequired;
      }
      if (!values.frequency) {
        errors.frequency = keyErrorsFieldRequired;
      }

      if (!values.smallLoanPayments) {
        errors.smallLoanPayments = keyErrorsFieldRequired;
      } else if (values.smallLoanPayments === 'yes') {
        if (!values.smallLoanPaymentsCount) {
          errors.smallLoanPaymentsCount = keyErrorsFieldRequired;
        }
        if (!removeNonDigitCharacters(values.smallLoanPaymentsTotalRepayments)) {
          errors.smallLoanPaymentsTotalRepayments = keyErrorsFieldRequired;
        }
        if (!values.smallLoanPaymentsFrequency) {
          errors.smallLoanPaymentsFrequency = keyErrorsFieldRequired;
        }
      }
    }
  } else {
    if (!values.payAdvancePayments) {
      errors.payAdvancePayments = keyErrorsFieldRequired;
    } else if (values.payAdvancePayments === 'yes') {
      if (isNullOrEmpty(values.payAdvancePaymentsCount)) {
        errors.payAdvancePaymentsCount = keyErrorsFieldRequired;
      }
      const repayment = removeNonDigitCharacters(values.payAdvancePaymentsTotalRepayments);

      if (!repayment || Number(repayment) === 0) {
        errors.payAdvancePaymentsTotalRepayments = keyErrorsFieldRequired;
      }
      if (!values.payAdvancePaymentsFrequencies) {
        errors.payAdvancePaymentsFrequencies = keyErrorsFieldRequired;
      }
    }
    if (!values.smallLoanPayments) {
      errors.smallLoanPayments = keyErrorsFieldRequired;
    } else if (values.smallLoanPayments === 'yes') {
      if (isNullOrEmpty(values.smallLoanPaymentsCount)) {
        errors.smallLoanPaymentsCount = keyErrorsFieldRequired;
      }
      const repayment = removeNonDigitCharacters(values.smallLoanPaymentsTotalRepayments);
      if (!repayment || Number(repayment) === 0) {
        errors.smallLoanPaymentsTotalRepayments = keyErrorsFieldRequired;
      }
      if (!values.smallLoanPaymentsFrequency) {
        errors.smallLoanPaymentsFrequency = keyErrorsFieldRequired;
      }
    }
    if (!values.homeLoanPayments) {
      errors.homeLoanPayments = keyErrorsFieldRequired;
    } else if (values.homeLoanPayments === 'yes') {
      const repayment = removeNonDigitCharacters(values.homeLoanPaymentsTotalRepayments);
      if (!repayment || Number(repayment) === 0) {
        errors.homeLoanPaymentsTotalRepayments = keyErrorsFieldRequired;
      }
      if (!values.homeLoanPaymentsFrequency) {
        errors.homeLoanPaymentsFrequency = keyErrorsFieldRequired;
      }
    }
    if (!values.otherLoanPayments) {
      errors.otherLoanPayments = keyErrorsFieldRequired;
    } else if (values.otherLoanPayments === 'yes') {
      if (isNullOrEmpty(values.otherLoanPaymentsCount)) {
        errors.otherLoanPaymentsCount = keyErrorsFieldRequired;
      }
      const repayment = removeNonDigitCharacters(values.otherLoanPaymentsTotalRepayments);
      if (!repayment || Number(repayment) === 0) {
        errors.otherLoanPaymentsTotalRepayments = keyErrorsFieldRequired;
      }
      if (!values.otherLoanPaymentsFrequency) {
        errors.otherLoanPaymentsFrequency = keyErrorsFieldRequired;
      }
    }
  }

  if (!values.creditCards) {
    errors.creditCards = keyErrorsFieldRequired;
  } else if (values.creditCards === 'yes') {
    if (isNullOrEmpty(values.creditCardsCount)) {
      errors.creditCardsCount = keyErrorsFieldRequired;
    }
    const repayment = removeNonDigitCharacters(values.totalLimit);
    if (!repayment || Number(repayment) === 0) {
      errors.totalLimit = keyErrorsFieldRequired;
    }
  }

  if (!values.creditBureauEnquiries) {
    errors.creditBureauEnquiries = keyErrorsFieldRequired;
  }

  if (!values.loanPurposeAdditionalInfo || values.loanPurposeAdditionalInfo.length > 255) {
    errors.loanPurposeAdditionalInfo = keyErrorsFieldRequired;
  }

  return errors;
};

export default validateLoan;
